// API hooks wrapper that switches between real API and demo mode
import * as MockHooks from '@/lib/demo-mode';
import { isDemoMode } from '@/lib/demo-mode';
import * as RealAPI from '@workspace/api-client-react';

// Query hooks
export const useListCourses = (options?: any) => {
  if (isDemoMode) {
    return MockHooks.useMockListCourses();
  }
  return RealAPI.useListCourses(options);
};

export const useListAppointments = (options?: any) => {
  if (isDemoMode) {
    return MockHooks.useMockListAppointments();
  }
  return RealAPI.useListAppointments(options);
};

export const useListUsers = (options?: any) => {
  if (isDemoMode) {
    return MockHooks.useMockListUsers();
  }
  return RealAPI.useListUsers(options);
};

export const useGetAnalyticsSummary = (options?: any) => {
  if (isDemoMode) {
    return MockHooks.useMockGetAnalyticsSummary();
  }
  return RealAPI.useGetAnalyticsSummary(options);
};

export const useGetTrafficByDay = (options?: any) => {
  if (isDemoMode) {
    return MockHooks.useMockGetTrafficByDay();
  }
  return RealAPI.useGetTrafficByDay(options);
};

export const useGetAppointmentsByStatus = (options?: any) => {
  if (isDemoMode) {
    return MockHooks.useMockGetAppointmentsByStatus();
  }
  return RealAPI.useGetAppointmentsByStatus(options);
};

// Mutation hooks
export const useCreateAppointment = () => {
  if (isDemoMode) {
    return MockHooks.useMockCreateAppointment();
  }
  return RealAPI.useCreateAppointment();
};

export const useUpdateAppointment = () => {
  if (isDemoMode) {
    return MockHooks.useMockUpdateAppointment();
  }
  return RealAPI.useUpdateAppointment();
};

export const useDeleteAppointment = () => {
  if (isDemoMode) {
    return MockHooks.useMockDeleteAppointment();
  }
  return RealAPI.useDeleteAppointment();
};

export const useCreateCourse = () => {
  if (isDemoMode) {
    return MockHooks.useMockCreateCourse();
  }
  return RealAPI.useCreateCourse();
};

export const useUpdateCourse = () => {
  if (isDemoMode) {
    return MockHooks.useMockUpdateCourse();
  }
  return RealAPI.useUpdateCourse();
};

export const useDeleteCourse = () => {
  if (isDemoMode) {
    return MockHooks.useMockDeleteCourse();
  }
  return RealAPI.useDeleteCourse();
};

export const useCreateUser = () => {
  if (isDemoMode) {
    return MockHooks.useMockCreateUser();
  }
  return RealAPI.useCreateUser();
};

export const useUpdateUser = () => {
  if (isDemoMode) {
    return MockHooks.useMockUpdateUser();
  }
  return RealAPI.useUpdateUser();
};

export const useGetRevenueStats = (options?: any) => {
  if (isDemoMode) {
    return MockHooks.useMockGetRevenueByMonth();
  }
  return RealAPI.useGetRevenueStats(options);
};

// Re-export query key getters
export const getListCoursesQueryKey = RealAPI.getListCoursesQueryKey;
export const getListAppointmentsQueryKey = RealAPI.getListAppointmentsQueryKey;
export const getListUsersQueryKey = RealAPI.getListUsersQueryKey;
export const getGetAnalyticsSummaryQueryKey = RealAPI.getGetAnalyticsSummaryQueryKey;
export const getGetTrafficByDayQueryKey = RealAPI.getGetTrafficByDayQueryKey;
export const getGetAppointmentsByStatusQueryKey = RealAPI.getGetAppointmentsByStatusQueryKey;
export const getGetRevenueStatsQueryKey = RealAPI.getGetRevenueStatsQueryKey;
